import styled from 'styled-components';
import { Row } from 'components/shared/Layout';

import { colours } from 'themes/default';

export const StyledPriceTable = styled(Row)`
  padding: 16px;
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
`;

export const StyledTableRow = styled(Row)`
  &:last-child {
    border-top: solid 1px #333;
    border-bottom: solid 1px #333;
  }
`;

export const StyledLabel = styled.label`
  display: block;
  margin-top: 16px;
`;

export const Spacer = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
`;
